import { useCategoryPageQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";

export const useLoggedOutCategoryPagePrevAndNextPageNumber = () => {
  const { oneIndexedPageNumber } = useCategoryPageQueryParams();

  const {
    data: { pageCount = 0 },
  } = useLoggedOutCategoryPageCatNavResponse();

  const next = oneIndexedPageNumber + 1;
  const prev = oneIndexedPageNumber - 1;

  return {
    prev: prev >= 1 ? prev : undefined,
    next: next <= pageCount ? next : undefined,
  };
};
